import { ClaimCardTypes } from '~components/SelectClaimStep/constants'

export const selectClaim = {
  claimType: ClaimCardTypes.NONE,
  claim: null,

  username: '',

  verificationTicket: '',
  verificationTicketExpiresInSeconds: 0,
  submittedAt: 0,
}
